export default class UrlProps {
  constructor() {
    this.dom = {
      $script: document.getElementById('ometriaJson')
        ? document.getElementById('ometriaJson').innerHTML
        : null,
    };
    this.state = {
      $url: false,
      $utm: false,
      $data: false,
      $params: false,
      $properties: false,
      $store: location.host,
    };
    this.mount();
  }
  get url() {
    return new URL(location.href);
  }
  get utm() {
    const { $url } = this.state;
    if (!$url) return false;

    const { searchParams: params } = $url;
    const utm = new Map();

    params.forEach((value, key) => {
      if (key.includes('utm')) utm.set(key, value);
    });
    return utm;
  }
  get params() {
    const { $url } = this.state;
    if (!$url) return false;

    const { search: params } = $url;
    return params;
  }
  get data() {
    const { $script } = this.dom;
    return JSON.parse($script);
  }
  get properties() {
    const { state } = this;
    if (!state.$url) return {};

    let data;
    const hasParams = state.$params !== '';

    if (hasParams) {
      data = {
        ...Object.fromEntries(state.$utm),
        query_params: state.$params,
      };
    } else {
      data = { ...Object.fromEntries(state.$utm) };
    }

    return data;
  }
  setState() {
    const { state } = this;
    const sessionData = JSON.parse(sessionStorage.getItem('_bl__url_props'));
    // If there's an existing UTM data then set that to the state
    // This will prevent the state from reseting on every single on load.
    if (sessionData) return (state.$properties = sessionData);

    state.$url = this.url;
    state.$utm = this.utm;
    state.$data = this.data;
    state.$params = this.params;
    state.$properties = this.properties;
  }

  /**
   * Tracks a 'Lower Case UTMs' event to Heap, ensuring all UTM property values
   * are converted to lowercase for consistent data analysis.
   * Paseses them individually bc they are unaccessible in Heap as an object.
   *
   * @param {string | undefined} utm_source - The source of the traffic.
   * @param {string | undefined} utm_content - The content that differentiates ads.
   * @param {string | undefined} utm_medium - The medium of the traffic.
   * @param {string | undefined} utm_campaign - The name of the campaign.
   */
  trackLowerCaseUTMs(utm_source, utm_content, utm_medium, utm_campaign) {
    // Cconvert a string to lowercase.
    // undefined or non-string inputs return undefined.
    const toLower = (str) =>
      typeof str === 'string' ? str.toLowerCase() : str;

    // Build the properties object with lowercase values
    const properties = {
      utm_source: toLower(utm_source),
      utm_content: toLower(utm_content),
      utm_medium: toLower(utm_medium),
      utm_campaign: toLower(utm_campaign),
    };

    // Log the event to Heap
    // Note: Heap will automatically filter out properties with an undefined value.
    if (typeof heap !== 'undefined' && heap.track) {
      heap.track('Lower Case UTMs', properties);
    } else {
      console.warn('Heap object is not available. Event not tracked.');
    }
  }
  setSessionData() {
    const { $properties } = this.state;

    if (Object.entries($properties).length === 0) return;

    // The state.$properties object contains all the UTMs as key/value pairs
    // e.g., { utm_source: 'Google', utm_campaign: 'Summer_SALE', ... }
    // We use object destructuring to pull out the UTMs needed for the track call.
    const { utm_source, utm_content, utm_medium, utm_campaign } = $properties;

    // Call the new class method, passing the values from the $properties object
    this.trackLowerCaseUTMs(utm_source, utm_content, utm_medium, utm_campaign);

    return sessionStorage.setItem(
      '_bl__url_props',
      JSON.stringify($properties)
    );
  }
  getUrlData() {
    const { $properties } = this.state;
    if ($properties) return $properties;
  }
  mount() {
    this.setState();
    this.setSessionData();
    window.Brooklinen = window.Brooklinen || {};
    window.Brooklinen.getUrlData = this.getUrlData.bind(this);
  }
}
